import React from 'react';
import { useState } from 'react';
import { AttachFileActionButton } from '../../../../../components/UI-Elements/FileUpload/AttachFileScreen/AttachFileActionButton';
import { ClientOrderQuote } from '../../../../../sp-types/clientOrderQuoteType';
import { LoadingLogoComponent } from '../../../../Quotes/LoadingLogoComponent';

interface Props {
  setNextPage: React.Dispatch<React.SetStateAction<number>>;
  setClientOrderState: React.Dispatch<React.SetStateAction<ClientOrderQuote>>;
}

export const ClientOrderCreateDrag: React.FC<Props> = ({ setClientOrderState, setNextPage }) => {
  const [isLoadingDoc, setIsLoadingDoc] = useState(false);
  const [dragSectionText, setDragSectionText] = useState<[string, string, string]>([
    'Attach File',
    'File attached',
    'Pending...',
  ]);
  const [actionButtonTexts, setActionButtonTexts] = useState<[string, string]>([
    'Create an order',
    'Click to create an order',
  ]);

  async function updateStateWhenFileUploaded() {
    setIsLoadingDoc(true);
    await new Promise((resolve) => setTimeout(resolve, 3000));
    setClientOrderState({
      productName: 'Tracking construction kit AW06',
      quantity: 30_000,
      pricePerUnit: 2_050,
      materialName: 'HRC ($750)',
      materialQuantity: 42_000,
      materialFormula: 'HRC x 1.4 + $1000',
      totalExpectedPrice: 61_500_000,
      contractType: { description: '-', name: '-', toolTip: '-' },
      DueDate: { month: 7, year: 2025 },
      DateRange: 'Nov, 2024 - Aug, 2025',
    });
    setDragSectionText(['Attach File', 'File attached', 'Completed']);
    setActionButtonTexts(['Continue', 'Modify and approve quote']);
    setIsLoadingDoc(false);
  }

  const [uploadedFiles, setUploadedFiles] = React.useState<string[]>([]);

  return (
    <div className="flex-1 h-full flex flex-col justify-center items-center relative">
      {isLoadingDoc && (
        <div className="absolute flex items-center justify-center inset-0">
          <LoadingLogoComponent />
        </div>
      )}
      <AttachFileActionButton
        dropZoneTitle={dragSectionText}
        actionButtonText={actionButtonTexts[1]}
        actionButtonTitle={actionButtonTexts[0]}
        handleActionButton={() => setNextPage((prev) => prev + 1)}
        handleSubmitWithFilePath={() => {
          updateStateWhenFileUploaded();
        }}
        onFilesChanged={(files) => {
          if (files?.length) {
            setUploadedFiles(files);
            updateStateWhenFileUploaded();
          }
        }}
        comments={[]}
        onCommentsChanged={() => 1}
        uploadedFiles={uploadedFiles}
      />
    </div>
  );
};
